import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { requestPasswordReset } from 'actions/settings';
import PasswordRequestForm from './PasswordRequestForm';
import PasswordRequestSuccess from './PasswordRequestSuccess';

class PasswordRequestFormContainer extends Component {
  /**
   * State
   * @type {Object}
   */
  state = {
    emailAddress: '',
  }

  componentWillUnmount = () => {
    this.setState({ emailAddress: '' });
  }

  /**
   * Handle change
   * @param  {Object} e
   * @return {undefined}
   */
  handleChange = (e) => {
    this.setState({ emailAddress: e.target.value });
  }

  /**
   * Reset
   * @param {[type]} e [description]
   */
  handleSubmit = (e) => {
    e.preventDefault();

    const { dispatch } = this.props;
    const { emailAddress } = this.state;

    if (emailAddress) {
      dispatch(requestPasswordReset(emailAddress));
    }
  }


  /**
   * Render
   * @return {JSX}
   */
  render() {
    const { isSuccess, message } = this.props;
    const { emailAddress } = this.state;

    if (isSuccess) {
      return <PasswordRequestSuccess />;
    }

    return (
      <PasswordRequestForm
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        message={message}
        value={emailAddress}
      />
    );
  }
}

PasswordRequestFormContainer.displayName = 'PasswordRequestFormContainer';

PasswordRequestFormContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

PasswordRequestFormContainer.defaultProps = {
  message: undefined,
};

const mapStateToProps = ({
  settings: {
    data,
    isFetching,
    isSuccess,
    message,
    subscriptions,
  },
}) => ({
  isFetching,
  isSuccess,
  data,
  subscriptions,
  message,
});

export default withRouter(connect(mapStateToProps)(PasswordRequestFormContainer));
